if (!customElements.get('dstrct-sticky-purchase')) {
  customElements.define('dstrct-sticky-purchase', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      this.scope = document.querySelector(`product-info[data-section="${this.dataset.section}"]`);
      this.form = document.getElementById(`product-form-${this.dataset.section}`);
      this.primary = this.form?.querySelector('[name="add"]');
      this.shortcut = this.querySelector('[data-sticky-submit]');
      this.price = this.querySelector('[data-sticky-price]');
      if (!this.scope || !this.primary || !this.shortcut) return;
      this.mobile = window.matchMedia('(max-width: 749px)');
      this.refresh = () => {
        this.primary = this.form.querySelector('[name="add"]');
        if (!this.primary) return;
        const priceRoot = document.getElementById(`price-${this.dataset.section}`);
        const onSale = priceRoot?.querySelector('.price--on-sale');
        const currentPrice = priceRoot?.querySelector(onSale ? '.price-item--sale' : '.price__regular .price-item--regular');
        if (currentPrice) this.price.textContent = currentPrice.textContent.trim();
        const text = this.primary.querySelector('span:not(.loading__spinner)');
        this.shortcut.textContent = text?.textContent.trim() || window.variantStrings.addToCart;
        this.shortcut.disabled = this.primary.disabled || this.primary.getAttribute('aria-disabled') === 'true';
        this.hidden = !this.mobile.matches || this.primaryVisible !== false;
        document.body.classList.toggle('dstrct-has-sticky', !this.hidden);
      };
      this.observer = new IntersectionObserver(([entry]) => { this.primaryVisible = entry.isIntersecting; this.refresh(); }, {threshold:0});
      this.observer.observe(this.primary);
      this.mutations = new MutationObserver(this.refresh);
      this.mutations.observe(this.scope, {subtree:true,childList:true,attributes:true,attributeFilter:['disabled','aria-disabled','class']});
      this.mobile.addEventListener('change', this.refresh, {signal:this.abort.signal});
      this.shortcut.addEventListener('click', () => {
        if (this.primary.disabled || this.primary.getAttribute('aria-disabled') === 'true') return;
        this.form.requestSubmit(this.primary);
      }, {signal:this.abort.signal});
      this.refresh();
    }
    disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); this.mutations?.disconnect(); document.body.classList.remove('dstrct-has-sticky'); }
  });
}
function dstrctReviewPlayback(root = document) {
  for (const section of root.querySelectorAll('.dstrct-video-reviews')) {
    if (section.dstrctPlaybackCleanup) continue;
    const videos = [...section.querySelectorAll('.dstrct-review-card video')];
    const button = section.querySelector('[data-review-playback]');
    if (!videos.length || !button) continue;
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const events = new AbortController();
    const visible = new Set();
    let paused = motion.matches;
    const update = () => {
      button.textContent = paused ? button.dataset.playLabel : button.dataset.pauseLabel;
      for (const video of videos) {
        if (!paused && !document.hidden && visible.has(video)) video.play().catch(() => {});
        else video.pause();
      }
    };
    const observer = new IntersectionObserver(entries => {
      for (const entry of entries) {
        if (entry.isIntersecting && entry.intersectionRatio >= 0.3) visible.add(entry.target);
        else visible.delete(entry.target);
      }
      update();
    }, { threshold: [0, 0.3] });
    for (const video of videos) {
      video.autoplay = false;
      observer.observe(video);
    }
    button.hidden = false;
    button.addEventListener('click', () => { paused = !paused; update(); }, { signal: events.signal });
    motion.addEventListener('change', () => { if (motion.matches) paused = true; update(); }, { signal: events.signal });
    document.addEventListener('visibilitychange', update, { signal: events.signal });
    section.dstrctPlaybackCleanup = () => {
      events.abort();
      observer.disconnect();
      videos.forEach(video => video.pause());
      delete section.dstrctPlaybackCleanup;
    };
    update();
  }
}
document.addEventListener('DOMContentLoaded', () => dstrctReviewPlayback());
document.addEventListener('shopify:section:load', event => dstrctReviewPlayback(event.target));
document.addEventListener('shopify:section:unload', event => {
  event.target.querySelectorAll('.dstrct-video-reviews').forEach(section => section.dstrctPlaybackCleanup?.());
});
